import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import * as reducers from '../ducks';

export default combineReducers({
  ...reducers,
  routing: routerReducer,
  form
});



// WEBPACK FOOTER //
// ./src/middleware/reducer.js